var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPegmanSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8183594,10.3017578C20.7255859,9.8154297,18.5166016,9,16,9s-4.7255859,0.8154297-5.8203125,1.3027344 C9.4628906,10.6230469,9,11.3398438,9,12.1289062V21c0,0.5527344,0.4472656,1,1,1h1.2558594l2.4990234,8.328125 C14.0488281,31.3125,14.9726562,32,16,32s1.9511719-0.6875,2.2451172-1.6708984L20.7441406,22H22c0.5527344,0,1-0.4472656,1-1 v-8.8710938C23,11.3398438,22.5371094,10.6230469,21.8183594,10.3017578z M21,20h-1 c-0.4414062,0-0.8310547,0.2900391-0.9580078,0.7128906l-2.7128906,9.0429688 c-0.0859375,0.2871094-0.5722656,0.2880859-0.6582031-0.0009766l-2.7128906-9.0419922C12.8310547,20.2900391,12.4414062,20,12,20 h-1v-7.8710938l-0.0058594,0.0009766C11.9423828,11.7080078,13.8535156,11,16,11s4.0576172,0.7080078,5,1.1289062V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8c1.8525391,0,3.5-2.5166016,3.5-4.5C19.5,1.4394531,18.0605469,0,16,0s-3.5,1.4394531-3.5,3.5 C12.5,5.4833984,14.1474609,8,16,8z M16,2c0.953125,0,1.5,0.546875,1.5,1.5C17.5,4.6660156,16.4355469,6,16,6 s-1.5-1.3339844-1.5-2.5C14.5,2.546875,15.046875,2,16,2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPegmanSmall);
export default __webpack_public_path__ + "static/media/pegman--small.d61338993d666da9a7959cb1e5e4c153.svg";
export { ForwardRef as ReactComponent };